const timeOptions = { hour: '2-digit', minute: '2-digit' };

export function formatDuration(ms) {
    const totalSeconds = Math.max(0, ms / 1000 | 0);
    return [totalSeconds / 3600 | 0, totalSeconds / 60 % 60 | 0, totalSeconds % 60].map(v => String(v).padStart(2, '0')).join(':');
};

export function formatLogDuration(startMs, endMs) {
    const totalSeconds = Math.max(0, Math.floor((endMs - startMs) / 1000));

    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return [hours, minutes, seconds].map(v => String(v).padStart(2, '0')).join(':');
}
export function formatLog(log) {
    const startMs = new Date(log.startTime).getTime();
    const endMs   = log.endTime ? new Date(log.endTime).getTime() : null;
    return {
        id: log.id,
        start: new Date(startMs).toLocaleTimeString('de-DE', timeOptions),
        end: endMs ? new Date(endMs).toLocaleTimeString('de-DE', timeOptions) : "Läuft...",
        duration: endMs ? formatLogDuration(startMs, endMs) : "/",
        startRaw: log.startTime,
        endRaw: log.endTime ?? null,
    };
}